(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["little-me-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-product')) {
    customElements.define(
      'atelier-product',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          const nameField = this.querySelector(
            '[name="properties[Naam]"]'
          );

          const liveFonts = this.querySelectorAll('[data-live-font]');

          const updateFontPreviews = () => {
            const previewText =
              nameField?.value.trim() || this.dataset.previewName;

            liveFonts.forEach(preview => {
              preview.textContent = previewText;
            });
          };

          updateFontPreviews();
          nameField?.addEventListener('input', updateFontPreviews);

          liveFonts.forEach(async preview => {
            try {
              const loadedFonts = await document.fonts.load(
                '32px "' + preview.dataset.fontFamily + '"'
              );

              if (!loadedFonts.length || !this.isConnected) return;

              preview.hidden = false;

              const fallback = preview.parentElement.querySelector(
                '[data-font-fallback]'
              );

              if (fallback) fallback.hidden = true;
            } catch {
              preview.hidden = true;
            }
          });

          this.querySelectorAll('[data-image-link]').forEach(link => {
            link.addEventListener('click', event => {
              const image = document.getElementById(link.hash.slice(1));
              const gallery = this.querySelector('.alm-product__gallery');

              if (!image || !gallery) return;

              event.preventDefault();

              gallery.scrollLeft =
                image.offsetLeft -
                gallery.querySelector('.alm-product__slide').offsetLeft;
            });
          });

          this.querySelector('[data-variant]')?.addEventListener(
            'change',
            event => {
              const option = event.target.selectedOptions[0];
              const price = this.querySelector('[data-price]');
              const compare = this.querySelector('[data-compare]');
              const submit = this.querySelector('[data-submit]');

              price.textContent = option.dataset.price;
              compare.textContent = option.dataset.compare;
              compare.hidden = !option.dataset.compare;

              submit.disabled = option.dataset.available !== 'true';
              submit.textContent = submit.disabled
                ? this.dataset.soldLabel
                : this.dataset.addLabel;

              const quantity = this.querySelector('[name="quantity"]');

              quantity.min = option.dataset.min || '1';
              quantity.step = option.dataset.step || '1';

              if (option.dataset.max) {
                quantity.max = option.dataset.max;
              } else {
                quantity.removeAttribute('max');
              }

              quantity.value = quantity.min;

              const image = document.getElementById(option.dataset.image);
              const gallery = this.querySelector('.alm-product__gallery');

              if (image && gallery) {
                gallery.scrollLeft =
                  image.offsetLeft -
                  gallery.querySelector('.alm-product__slide').offsetLeft;
              }

              const url = new URL(window.location.href);
              url.searchParams.set('variant', option.value);
              window.history.replaceState({}, '', url);
            }
          );

          this.querySelector('form')?.addEventListener('submit', event => {
            const field = this.querySelector('[name="properties[Naam]"]');

            if (field && !field.value.trim()) {
              event.preventDefault();
              field.value = '';
              field.reportValidity();
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
